import router from '@/router'
import exploreRoute from './explore/explore.routes'
import dealsRoute from './deals/deals.routes'
import { AppSidebar, AppHeader } from '@/components'

export default () => {
  router.addRoute({
    path: '/funding',
    name: 'funding',
    redirect: { name: 'loan-matches' },
    components: {
      default: () => import('./funding.vue'),
      sidebar: AppSidebar,
      header: AppHeader
    },
    children: [exploreRoute, dealsRoute]
  })
}
